export const baseUrl = 'products';
export const productExBaseUrl = 'products-ext';

export const ApiProduct = {
  GetProductDetail: (id: string) => `${baseUrl}/v2/${id}`,
  getOffersByProductId: (id: string) => `${productExBaseUrl}/${id}/offerings/list?nonSellable=false`
};
